import { render } from "./TarifasVistaComponent.vue?vue&type=template&id=56fb66c0"
import script from "./TarifasVistaComponent.vue?vue&type=script&lang=js"
export * from "./TarifasVistaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__